/* ============================================================
   VEGECORE — Exit-intent popup (custom, no app), updated 2026-08-03
   Shows TRYVEGECORE (first-purchase 10% off) once per browser.
   FAST TRIGGER: fires on a short universal timer (~2.5s) on BOTH
   mobile and desktop, so it no longer waits for a 45s mobile timer
   or relies solely on desktop exit-intent. Exit-intent is kept as
   an EARLY bonus trigger on desktop (fires sooner if the visitor
   tries to leave before the timer elapses).
   Skipped on cart/checkout templates. Only loaded for guests /
   customers with 0 prior orders (guarded in layout/theme.liquid).
   ============================================================ */
(function () {
  var CODE = 'TRYVEGECORE';
  var STORAGE_KEY = 'vcExitPopupSeen';
  var SHOW_DELAY_MS = 2500;  // universal fast-trigger delay (was 45000 on mobile)
  var MIN_TIME_MS = 800;     // tiny guard so exit-intent can't fire on page-load jitter

  try {
    if (localStorage.getItem(STORAGE_KEY)) return;
  } catch (e) {}

  var skipClasses = ['template-cart', 'template-checkout'];
  var bodyClass = document.body.className || '';
  for (var i = 0; i < skipClasses.length; i++) {
    if (bodyClass.indexOf(skipClasses[i]) !== -1) return;
  }

  var startTime = Date.now();
  var shown = false;
  var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  function buildPopup() {
    var overlay = document.createElement('div');
    overlay.className = 'vc-exitpop-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'First purchase discount offer');
    overlay.innerHTML =
      '<div class="vc-exitpop">' +
        '<button class="vc-exitpop-close" aria-label="Close">&times;</button>' +
        '<div class="vc-exitpop-eyebrow">Before you go</div>' +
        '<h3>Here&rsquo;s 10% off</h3>' +
        '<p>First time here? Take 10% off your first order, on us.</p>' +
        '<div class="vc-exitpop-code"><span>' + CODE + '</span><button type="button" data-copy>Copy</button></div>' +
        '<a class="btn btn-accent btn-lg vc-exitpop-cta" href="/discount/' + CODE + '?redirect=%2Fcollections%2Fall">Shop now</a>' +
      '</div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  function openPopup() {
    if (shown) return;
    shown = true;
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}

    var overlay = buildPopup();
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });

    function close() {
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.remove(); }, 250);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.vc-exitpop-close').addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    overlay.querySelector('[data-copy]').addEventListener('click', function () {
      var btn = this;
      function fallbackCopy() {
        var ta = document.createElement('textarea');
        ta.value = CODE;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CODE).catch(fallbackCopy);
      } else {
        fallbackCopy();
      }
      var original = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(function () { btn.textContent = original; }, 1800);
    });
  }

  // Fires quickly for everyone, mobile and desktop alike.
  setTimeout(openPopup, SHOW_DELAY_MS);

  // Desktop bonus: if they try to leave before the timer above fires, show it right away.
  if (!isTouch) {
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0 && Date.now() - startTime > MIN_TIME_MS) {
        openPopup();
      }
    });
  }
})();
